export enum UserTypeEnum {
    FD = 'FD',
    ALLIANCE = 'ALLIANCE',
    MERCHANT = 'MERCHANT',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    LATAM_ALLIANCE = 'LATAM_ALLIANCE',
    GRAFANA = 'GRAFANA'

}
